// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"styles_testimonial___6TSY","testimonial__quote":"styles_testimonial__quote__BaouO","testimonial__byline":"styles_testimonial__byline__PLLVt"};